// Media-capability detection (design/09 EC, modules/04 §6). getUserMedia /
// getDisplayMedia are only exposed in a SECURE CONTEXT (HTTPS, or http://localhost). When
// the POC is served over plain HTTP at a custom host (e.g. http://mopsconf.igates.local),
// navigator.mediaDevices is undefined and the raw call throws
// "Cannot read properties of undefined (reading 'getUserMedia')" — leaving black panels.
// We detect this up front and surface an actionable Hebrew error instead. Pure +
// unit-tested.

export type MediaSupport = "ok" | "insecure-context" | "unsupported";

export function checkMediaSupport(secureContext: boolean, hasMediaDevices: boolean, hasGetUserMedia: boolean): MediaSupport {
  if (!secureContext) return "insecure-context";
  if (!hasMediaDevices || !hasGetUserMedia) return "unsupported";
  return "ok";
}

/** Map a non-OK support state to the UI error code (i18n he.errors). */
export function mediaSupportCode(support: MediaSupport): string {
  return support === "insecure-context" ? "VC-MEDIA-004" : "VC-MEDIA-001";
}

export class MediaUnavailableError extends Error {
  constructor(readonly support: MediaSupport) {
    super(`media unavailable: ${support}`);
    this.name = "MediaUnavailableError";
  }
}

/** Live evaluation against the current window/navigator. */
export function evaluateMediaSupport(): MediaSupport {
  const secure = typeof window !== "undefined" && window.isSecureContext === true;
  const md = typeof navigator !== "undefined" ? navigator.mediaDevices : undefined;
  return checkMediaSupport(secure, !!md, typeof md?.getUserMedia === "function");
}
